/** Texto plano con CSS suelto (p. ej. html.replace(/<[^>]+>/g) sobre un email HTML). */
export function looksLikeStrippedHtmlEmail(value) {
  const t = String(value || "").trim();
  if (!t || t.length < 40) return false;
  if (/<[a-z][\s/>]/i.test(t)) return false;
  return (
    /[{][^}]+[}]/.test(t) &&
    /(@media|html\s*\{|#[a-zA-Z0-9_-]+\s*\{|\.[a-zA-Z_-]+\s*\{)/.test(t)
  );
}

/** El backend ya eligió HTML; no re-filtrar en cliente (evita bucles con text/plain en API). */
export function pickDisplayBodyHtml(data) {
  const html = String(data?.html ?? "").trim();
  if (html.includes("<")) return html;

  const text = String(data?.text ?? "").trim();
  if (!html && text && looksLikeStrippedHtmlEmail(text)) {
    return "";
  }

  return html || text || "";
}
